export default {
    name: 'TimelineEntryItem',
    props: {
        timelineLayout: {
            type: Boolean,
            required: false,
            default: false
        },
        isLastDiscussion: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
